import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo(0, 0);
            return;
        }

        const id = decodeURIComponent(hash.replace('#', ''));
        let attempts = 0;

        const scrollToHash = () => {
            const element = document.getElementById(id);

            if (element) {
                element.scrollIntoView({ block: 'center', inline: 'nearest' });
                return;
            }

            if (attempts < 20) {
                attempts += 1;
                requestAnimationFrame(scrollToHash);
            }
        };

        scrollToHash();
    }, [pathname, hash]);

    return null;
}

export default ScrollToTop;
